import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function BusinessResources() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Media Stream</span>
                    </div>
                </section>


                <section class="pad bank-benefits default business_resources">

                    <div class="content normal">

                        <div class="img-frame img-width40">

                            <img src="images/nugenesisou/pr-illustration-28.png" alt="" />
                        </div>

                        <div class="data margin-top-content">
                            <div class="text">
                                <h3 class="title">The Asset Revolution - NAMS</h3>
                                <p class="subtitle">
                                    Nugeenesis Asset Management System (NAMS) is a fully completed
                                    network of layer 1 native blockchains. The system involves multiple
                                    interoperable cross chains, parallel processing, to achieve unlimited
                                    speeds and scalability. It is designed to cater for the mass adoption of
                                    blockchain technology and accommodate the transition from the internet
                                    to the metaverse.The system is designed to accommodate the evolution
                                    of interactive NFTs™ and other Digital assets representing value being
                                    created, levelling up and being exchanged: whether in physical,
                                    augmented or virtual reality.

                                </p>

                            </div>
                            <br></br>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Digital_Land_m2_Tokenisation.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>



                        </div>

                    </div>

                </section>

                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Nugenesis Onboarding Process</h3>
                                <p class="subtitle">
                                    In an increasingly digital and interconnected world, the process of user
                                    onboarding has evolved into a critical touchpoint that directly impacts user
                                    trust, engagement, and overall platform success. This document aims to
                                    provide a comprehensive understanding of the Nugenesis onboarding
                                    processes, particularly focusing on the revolutionary role of our AIpowered system, NAVIS, in enhancing identity verification.

                                </p>

                            </div>

                            <br></br>
                            <br></br>

                            <div class="text">
                                <h3 class="title">Access Links To Project Database</h3>
                                

                            </div>

                            <div class="btns marign-low-bottom-up">
                                <a href="document/Nugenesis-Onboarding-Processes-and-AI-report-1.docx" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>



                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/abt-illustration-2.png" alt="" />
                        </div>
                    </div>

                </section>







                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">R&D Documents</h3>
                                <p class="subtitle">
                                Daily and weekly reportings of Nugenesis’s Blockchain Development
                                </p>
                            </div>

                            <div class="btns marign-low-bottom-25">
                                <a href="document/Daily-Checks-Blockchain.xlsx" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>



                            <div class="text">
                                
                                <p class="subtitle">
                                Node reportings of Nugenesis’s Blockchain Development
                                </p>
                            </div>

                            <div class="btns marign-low-bottom-25">
                                <a href="document/2021-2022-blockchain-R-D-Nodes.xlsx" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>



                            <div class="text">
                                
                                <p class="subtitle">
                                Nugenesis R&D Documents
                                </p>
                            </div>

                            <div class="btns marign-low-bottom-25">
                                <a href="document/01_ZACU-Marketing_D1.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-29.png" alt="" />
                        </div>
                    </div>
                    <div class="content normal">
                        <div class="data">

                            <div class="text">
                                <h3 class="title">OTC OPPORTUNITIES</h3>
                                <p class="subtitle">
                                Compilation of documentents of OTC deals conducted by Nugensis
                                </p>
                            </div>
                            <div class="btns marign-low-bottom-25">
                                <a href="document/Company-Constitution.pdf" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            

                            


                        </div>
                        <div class="img-frame img-width40">
                            <img src="images/nugenesisou/pr-illustration-31.png" alt="" />
                        </div>
                    </div>
                </section>




                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            
                            <div class="text">
                                <h3 class="title">Research And Development Department</h3>
                            </div>

                            <p class="subtitle">
                            A compilation of Nugenesis’s Research and Development Department
                            reporst and prog
                            </p>

                            <div class="btns marign-low-bottom-25">
                                <a href="document/AI-Analytic-Services-2BTosend.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                            <div class="text">
                                <p class="subtitle">
                                Access Links To Project Database
                                </p>

                                

                            </div>
                            <div class="btns marign-low-bottom-25">
                                <a href="https://app.smartsheet.com/b/home?dlp=%2Fsheets%2Ffc9pfPXG8cqGhXCPPvgmP5GPV7X63Mgq63Wr8Mf1" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                           

                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-30.png" alt="" />
                        </div>
                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}